<template>
  <b-row class="base-row-padded">
    <b-col>
      <PlaylistsViewer :playlist-type="'playlists'"/>
    </b-col>
  </b-row>
</template>

<script>
import PlaylistsViewer from '@/components/PlaylistsViewer.vue';

export default {
  components: { PlaylistsViewer },

};
</script>
